import { breakpoints } from '@/themes/themeOverrides/Breakpoints';
import { Palette } from '@/themes/themeOverrides/Palette';

export const brandConfigurationDetailsStyles = {
    '& .brand-configuration-details__row': {
        display: 'grid',
        gridTemplateColumns: '256px minmax(0, 1fr) minmax(170px, 170px)',
        columnGap: '10px',
        alignItems: 'baseline',
        borderTop: `2px solid ${Palette.gray.gray75}`,
        borderBottom: `2px solid ${Palette.gray.gray75}`,
        marginBottom: '-2px',
        padding: '12px 0',
        [`@media (max-width: ${breakpoints.values.md}px)`]: {
            gridTemplateColumns: '1fr',
            rowGap: '4px',
        },
    },
    '& .brand-configuration-details__label': {
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '18px',
        color: Palette.gray.gray600,
    },
    '& .brand-configuration-details__value': {
        fontSize: '14px',
        fontWeight: 500,
        lineHeight: '18px',
        color: Palette.gray.gray900,
        minWidth: 0,
        [`@media (max-width: ${breakpoints.values.md}px)`]: {
            wordBreak: 'break-word',
        },
        '& .MuiTypography-root': {
            fontSize: '14px',
            fontWeight: 500,
            lineHeight: '18px',
            color: Palette.gray.gray900,
        },
    },
    '& .brand-configuration-details__source': {
        fontSize: '11px',
        fontWeight: 400,
        lineHeight: '16px',
        color: Palette.gray.gray600,
    },
};
